// Libraries
import { Grid } from "@mui/material";
import { memo } from "react";

// Types
import { TDrawDepartment } from "../types";

// Components
import DrawDepartmentItem from "./DrawDepartmentItem";

type TDrawDepartmentSectionProps = {
	globalSearch: string;
	data: TDrawDepartment[];
	generateKey: (value: string) => string;
};

function DrawDepartmentSection(props: Readonly<TDrawDepartmentSectionProps>) {
	const { data, globalSearch, generateKey } = props;

	return (
		<Grid container item mt={0} rowSpacing={2}>
			{data.map(({ department, listPositions }, index) => (
				<DrawDepartmentItem
					key={generateKey(department)}
					departmentName={department}
					positions={listPositions}
					displayDivider={data.length !== index + 1}
					globalSearch={globalSearch}
				/>
			))}
		</Grid>
	);
}

export default memo(DrawDepartmentSection);
